import React from "react";
import { ComponentProps } from "../../types";

interface Props extends ComponentProps {
  id: string;
  background?: string;
}

const DivWrapper: React.FC<Props> = ({
  anchor,
  hideOnMobile,
  id,
  background,
  children,
}) => {
  const styles: React.CSSProperties = {};

  if (background) {
    styles.background = background;
  }

  return (
    <div
      data-kontent-component-id={id}
      id={anchor !== "" ? anchor : undefined}
      className={hideOnMobile ? "hide-mobile" : undefined}
      style={styles}
    >
      {children}
    </div>
  );
};

export default DivWrapper;
